import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Ungroup: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '8', height: '6', x: '5', y: '4', rx: '1' }],
    ['rect', { width: '8', height: '6', x: '11', y: '14', rx: '1' }],
  ],
];

export default Ungroup;
